/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the proportion of a codon among all synonymous codons for its amino acid. If leucine is encoded 10 times and CTG accounts for 4 of them, CTG's fraction is 0.40.`)
};

const es_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es la proporción de un codón entre todos los codones sinónimos de su aminoácido. Si la leucina se codifica 10 veces y CTG representa 4 de ellas, la fracción de CTG es 0.40.`)
};

const de_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist der Anteil eines Codons unter allen synonymen Codons für seine Aminosäure. Wenn Leucin 10 Mal kodiert wird und CTG davon 4 Mal, beträgt der Anteil von CTG 0,40.`)
};

const nl_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is het aandeel van een codon tussen alle synonieme codons voor zijn aminozuur. Als leucine 10 keer wordt gecodeerd en CTG daarvan 4 keer, is de fractie van CTG 0,40.`)
};

const fr_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est la proportion d'un codon parmi tous les codons synonymes de son acide aminé. Si la leucine est codée 10 fois et que CTG en représente 4, la fraction de CTG est 0,40.`)
};

const it_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È la proporzione di un codone tra tutti i codoni sinonimi del suo amminoacido. Se la leucina è codificata 10 volte e CTG ne rappresenta 4, la frazione di CTG è 0,40.`)
};

const pt_br2_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a proporção de um códon entre todos os códons sinônimos de seu aminoácido. Se a leucina é codificada 10 vezes e CTG representa 4 delas, a fração de CTG é 0,40.`)
};

const pt_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a proporção de um codão entre todos os codões sinónimos do seu aminoácido. Se a leucina for codificada 10 vezes e CTG corresponder a 4 delas, a fração de CTG é 0,40.`)
};

const ja_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`そのアミノ酸のすべての同義コドンの中で、あるコドンが占める割合です。ロイシンが10回コードされ、そのうちCTGが4回であれば、CTGの割合は0.40です。`)
};

const zh_codon_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是某个密码子在其氨基酸所有同义密码子中所占的比例。如果亮氨酸被编码 10 次，其中 CTG 占 4 次，那么 CTG 的比例就是 0.40。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_faq_a3", locale)
	if (locale === "en") return en_codon_faq_a3(inputs)
	if (locale === "es") return es_codon_faq_a3(inputs)
	if (locale === "de") return de_codon_faq_a3(inputs)
	if (locale === "nl") return nl_codon_faq_a3(inputs)
	if (locale === "fr") return fr_codon_faq_a3(inputs)
	if (locale === "it") return it_codon_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_codon_faq_a3(inputs)
	if (locale === "pt") return pt_codon_faq_a3(inputs)
	if (locale === "ja") return ja_codon_faq_a3(inputs)
	return zh_codon_faq_a3(inputs)
};